import { DataMappingEntity } from "../Common/DataMappingEntity"

export interface EstimatedUnbillFigureEntity extends DataMappingEntity {
    year: string | null,
    month: string | null,
    amount: string | null,

    [key: string]: string | number | Date | null | undefined
}

export const EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY: EstimatedUnbillFigureEntity = {
    id: 0,
    year: null,
    month: null,
    amount: null,
    priority: 0,
    effectiveDate: null,
    expiryDate: null,
    confirmedDate: null,
    activeInd: 'Y',
    mappingType: "EstimatedUnbillFigureEntity"
}